import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faNotes } from '@fortawesome/pro-solid-svg-icons';
import { ClientsTableComponent } from '../../../../clients-table/clients-table.component';
import { ConstitutionCapitalStore } from '../../stores/constitution-capital.store';

@Component({
  selector: 'app-constitution-capital-series-section',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CheckboxModule,
    InputNumberModule,
    DropdownModule,
    InputTextModule,
    FontAwesomeModule,
    ClientsTableComponent,
  ],
  templateUrl: './constitution-capital-series-section.component.html',
  styleUrl: '../../constitution-form.component.scss',
})
export class ConstitutionCapitalSeriesSectionComponent {

  store = inject(ConstitutionCapitalStore);
  clientId = input<number | null>(null);
  deferPersistence = input(false);
  seriesChanged = output<void>();
  readonly faNotes = faNotes;

  saveSerieModal(): void {
    const structuralChange = this.store.saveItem(this.clientId(), this.deferPersistence());
    if (structuralChange) {
      this.seriesChanged.emit();
    }
  }

  onDeleteSerie(index: number): void {
    void this.store.deleteItem(index, this.deferPersistence()).then(() => {
      this.seriesChanged.emit();
    });
  }
}
